import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import './styles.scss'

// 1. Importamos auth desde nuestro nuevo archivo limpio
import { auth } from './firebaseConfig'
import { onAuthStateChanged } from "firebase/auth"

Vue.config.productionTip = false

let app = null;

// 2. Esperamos a Firebase antes de iniciar Vue
onAuthStateChanged(auth, () => {
  // Solo inicializamos la instancia de Vue si no existe ya.
  // Esto asegura que cargamos la app SOLO cuando sabemos el estado del usuario (logueado o no).
  if (!app) {
    app = new Vue({
      vuetify,
      router,
      render: h => h(App)
    }).$mount('#app')
  }
});